












































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import GeneralTermListBase from "./GeneralTermListBase";

	@Component
	export default class generalTermList extends GeneralTermListBase {
		created() {
            super.initializeRights('COR_GeneralTermsandCondition_Update', 'COR_GeneralTermsandCondition_Update', 'COR_GeneralTermsandCondition_Update', 'COR_GeneralTermsandCondition_Update');
            super.setDetailName('GeneralTermDetail');
			super.created();
		
        }

        nameConsent() {
            return this.$t('generalTerm.buttonConsentTooltip').toString();
        }

        nameDonwload() {
            return this.$t('generalTerm.buttonDownloadTooltip').toString();
        }

		selectRows(items: any) {
			super.selectRows(items);
		}

        isSuperUserAllow(){
			return this.isSuperUser;
        }

        showAgreeButton() {
            this.showAgreeButtonBase();
        }

        agreeClick(item:any) {
            this.agreeClickBase(item);
        }

        downloadClick(item:any) {
            this.downloadClickBase(item);
        }

		//private sendAgain(items: any) {
		//	this.sendAgainBase(items);
		//}

		showAllertToDeleteClick(itemsSelected: any) {
			this.showAlertBeforeDeleteBase(itemsSelected);
		}


		loadFilters(value: any) { super.loadFilters(value); }
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); }
		deleteClick(elementId: any) { this.deleteClick(elementId) }
	};
